export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/14ed8dc335eec8ccd043173219a4387f.svg";